<template>
  <div class="main-chapter">
    <div class="loader" v-if="!external || external.length === 0">
      {{ $t("lesson.external-game.loading") }}
      <!-- <v-progress-circular indeterminate color="primary"></v-progress-circular> -->
      <div
        style="text-align: center; display: flex; justify-content: center; margin: 8px;"
      >
        <SlinkyVue />
      </div>
    </div>
    <LessonHeader
      :style="safeTopVar"
      v-if="intro"
      class="lessonOnTop"
      :outerData="game.name"
      :externalType="game.game_type"
      @closeIntro="closeIntro"
    ></LessonHeader>
    <div v-if="loading" style="text-align: center;">
      <!-- <v-progress-circular indeterminate color="primary"></v-progress-circular> -->

      {{ $t("lesson.external-game.loading-game") }}
      <!-- <v-progress-circular indeterminate color="primary"></v-progress-circular> -->
      <div
        style="text-align: center; display: flex; justify-content: center; margin: 8px;"
      >
        <SlinkyVue />
      </div>
    </div>
    <!-- <button v-if="intro" class="backBtnModal" @click="goBack">
      <inline-svg
        class="back-svg"
        :src="require('../../assets/svg/back.svg').default"
      ></inline-svg>
    </button> -->
    <OnBoardingModal
      v-if="intro"
      type="game"
      :text="intro_text"
      :audioSrc="intro_audio"
      :imgSrc="intro_image"
      :vidSrc="intro_video"
      :id="id"
      @clicked="clicked"
    />
    <div v-else-if="external" class="chapter-course">
      <div
        :key="section.name"
        v-for="section of external"
        :style="{
          height: calculateHeight(section)
        }"
        class="collapsed"
      >
        <div class="lesson-type" @click="pickType(section)">
          <div>
            <div>
              <h5>{{ section["name"] }}</h5>
            </div>
          </div>
          <div class="arrow">
            <inline-svg
              :src="require('../../assets/svg/arrow-down.svg').default"
              :class="pickedType == section ? 'upside-arrow' : 'down-arrow'"
            ></inline-svg>
          </div>
        </div>
        <div class="lesson-wrapper">
          <div
            :key="game.id"
            v-for="game of section.games"
            @click="getGame(game)"
            class="step "
            :class="{ completed: userGames.includes(game.id) }"
          >
            <div class="v-stepper-course">
              <div class="circle">
                <inline-svg
                  v-if="userGames.includes(game.id)"
                  class="check-v-ex"
                  :src="require('../../assets/svg/GreenCheck.svg').default"
                ></inline-svg>
              </div>
              <div
                class="lesson-icon"
                v-if="
                  game.permission !== 'unknown' &&
                    game.permission !== permission &&
                    permission !== 'paying'
                "
              >
                <inline-svg
                  v-if="
                    game &&
                      game.permission !== 'unknown' &&
                      game.permission !== permission &&
                      permission !== 'paying'
                  "
                  class="lockSign"
                  width="14px"
                  height="14px"
                  :src="require('../../assets/svg/lock.svg').default"
                />
                <inline-svg
                  v-if="
                    game &&
                      game.permission !== 'unknown' &&
                      game.permission !== permission &&
                      permission !== 'paying' &&
                      game.permission == 'registered'
                  "
                  width="14px"
                  height="14px"
                  :src="require('../../assets/svg/googleicon.svg').default"
                />
              </div>
            </div>
            <div
              class="gameText"
              :class="{
                gameContent: true,
                disbaledText:
                  game.permission !== 'unknown' &&
                  game.permission !== permission &&
                  permission !== 'paying'
              }"
            >
              {{ game.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "./external-game.scss";
import Arrow from "../../assets/svg/arrow-left.svg";
import lesson from "../../assets/svg/lesson.svg";
import wordshalf from "../../assets/svg/wordshalf.svg";
import wordsfull from "../../assets/svg/wordsfull.svg";
import grammar from "../../assets/svg/grammar.svg";
import sentences from "../../assets/svg/sentences.svg";
import course from "../../store/course";
import VideoPlayer from "../Shared/VideoPlayer.vue";

import { courseService } from "../../services/courseService";
import { userService } from "../../services/userService";
import OnBoardingModal from "../onBoardingModal/OnBoardingModal.vue";
import LessonHeader from "./lesson-header.vue";
import SlinkyVue from "../Shared/Slinky.vue";

export default {
  name: "Externals",
  props: ["exType", "permission"],
  data() {
    return {
      external: null,
      chapter: null,
      choose: null,
      sounds: false,
      type: null,
      pickedType: "",
      id: null,
      game: null,
      loading: false,
      intro: false,
      intro_video: null,
      intro_audio: null,
      intro_image: null,
      intro_text: null,
      introClose: null,
      Arrow,
      imgTypes: {
        lesson,
        wordshalf,
        wordsfull,
        grammar,
        sentences
      },
      types: {
        lesson: this.$t("lesson.external-game.lesson"),
        wordshalf: this.$t("lesson.external-game.wordshalf"),
        wordsfull: this.$t("lesson.external-game.wordsfull"),
        sentences: this.$t("lesson.external-game.sentences"),
        grammar: this.$t("lesson.external-game.grammar")
      }
    };
  },
  async mounted() {
    console.log(this.exType);
    if (this.exType) {
      this.type = this.exType;
    } else if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (this.type) {
      this.external = this.filterExternals(this.type);
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    userGames() {
      if (this.user) {
        const games = this.user.games
          .filter(game => game.is_done)
          .map(game => game.game.id);
        return games;
      }
      return [];
    },
    externals() {
      return this.$store.getters.externals;
    },
    safeTopVar() {
      return { "--top": this.$store.getters.safeTop + "px" };
    }
  },
  methods: {
    clicked(event) {
      console.log("closed intro", event);
      this.$emit("showFooter");
      this.introClose = true;
      if (this.game) this.playGame(this.game);
    },
    goPay() {
      this.$router.push({
        path: `/registration`
      });
    },
    filterExternals(gameType) {
      return this.externals
        .map(res => {
          return {
            ...res,
            games: res.games.filter(res => res.game_type == gameType)
          };
        })
        .filter(section => section.games.length);
    },
    checkPermission(game, userPermission) {
      if (game.permission === "unknown" || userPermission === "paying")
        return true;
      else if (game.permission === userPermission) return true;
      else return false;
    },
    calculateHeight(type) {
      return this.pickedType === type
        ? type.games.length * 60 + 70 + "px"
        : "54px";
    },
    pickType(type) {
      if (this.pickedType === type) {
        this.pickedType = "";
        return;
      }
      this.pickedType = type;
    },
    goBack() {
      this.$emit("showFooter");
      this.playUrl = null;
      this.intro = false;
      this.introClose = true;
      // this.$router.push({
      //   path: `/external-${this.exType}`
      // });
    },
    getGame(game) {
      this.game = game;
      this.id = game.id;
      if (this.loading == true) return;
      if (
        game.intro_video ||
        game.intro_text ||
        game.intro_image ||
        game.intro_audio
      ) {
        this.intro_video = game.intro_video;
        this.intro_text = game.intro_text;
        this.intro_image = game.intro_image;
        this.intro_audio = game.intro_audio;
        if (game && this.checkPermission(game, this.permission)) {
          this.loading = true;
          this.intro = true;
          this.introClose = false;
          this.$emit("hideFooter");
          this.loading = false;
        } else {
          if (game && game.permission == "paying") this.goPay();
        }
        console.log("INTRO");
      } else {
        this.introClose = true;
        console.log("NO INTRO");
        this.playGame(game);
      }
    },
    closeIntro() {
      this.playUrl = null;
      this.$emit("showFooter");
      this.intro = false;
      this.introClose = true;
      console.log("EMITTED");
    },
    async playGame(game) {
      if (game && this.checkPermission(game, this.permission)) {
        if (this.user) {
          this.loading = true;
          await userService.startGame(game.id);
          this.loading = false;
        }
        this.$router.push({
          path: `/${game.game_type}/${game.algolia_game_id}/?id=${game.id}&name=${game.name}`
        });
      } else {
        console.log("a", game.permission);
        if (game.permission == "paying") this.goPay();
      }
    },
    goTo: function(lesson) {
      // this.$store.commit({
      //   type: "setCurrentGame",
      //   lesson,
      //   courseId: course.order,
      //   courseName: course.name
      // });
      // this.$router.push({
      //   path: `../play/${lesson.type}/${lesson.game_id}`
      // });
      console.log("OK");
    }
  },
  watch: {
    async type() {
      this.external = this.filterExternals(this.type);
    },
    async exType() {
      this.type = this.exType;
    },
    externals() {
      this.external = this.filterExternals(this.type);
    }
  },
  components: { OnBoardingModal, LessonHeader, SlinkyVue }
};
</script>



// WEBPACK FOOTER //
// external-game.vue?030135d8